export const ACH_PAYMENT_TYPE = "ACH";
export const CARD_PAYMENT_TYPE = "CARD";
export const ACH_METHOD = "BANK_ACCOUNT";
export const CC_METHOD = "CREDIT_CARD";
export const CASH_METHOD = "CASH";
// captcha providers
export const TURNSTILE = "TURNSTILE";
